/**
 * Spending-by-category card — pie chart with the top-6 categories legend.
 */
import React from 'react';
import { Card } from '../ui/card';
import { PieChart, Pie, Cell, ResponsiveContainer, Tooltip } from 'recharts';
import { DASHBOARD_PALETTE, formatCurrency } from './constants';

export default function CategoryBreakdownCard({ categoryBreakdown, currency }) {
  const data = Object.entries(categoryBreakdown || {})
    .map(([name, value]) => ({ name, value }))
    .sort((a, b) => b.value - a.value)
    .slice(0, 6);

  return (
    <Card className="card-surface p-6" data-testid="category-breakdown-card">
      <h2 className="font-serif text-xl text-charcoal mb-4">Spending by Category</h2>
      {data.length > 0 ? (
        <div className="flex items-center gap-3">
          <div className="w-28 h-28 flex-shrink-0">
            <ResponsiveContainer width="100%" height="100%">
              <PieChart>
                <Pie data={data} cx="50%" cy="50%" innerRadius={30} outerRadius={45} paddingAngle={2} dataKey="value">
                  {data.map((_, i) => <Cell key={i} fill={DASHBOARD_PALETTE[i % DASHBOARD_PALETTE.length]} />)}
                </Pie>
                <Tooltip
                  formatter={(v) => formatCurrency(v, currency)}
                  contentStyle={{ backgroundColor: 'rgba(255,255,255,0.95)', border: '1px solid #CCC2BC', borderRadius: '4px', fontSize: '12px' }}
                />
              </PieChart>
            </ResponsiveContainer>
          </div>
          <div className="flex-1 space-y-1">
            {data.map((item, i) => (
              <div key={item.name} className="flex items-center justify-between text-xs">
                <div className="flex items-center gap-1.5">
                  <div className="w-2 h-2 rounded-full" style={{ backgroundColor: DASHBOARD_PALETTE[i % DASHBOARD_PALETTE.length] }} />
                  <span className="text-muted truncate max-w-[80px]">{item.name}</span>
                </div>
                <span className="font-mono text-charcoal">{formatCurrency(item.value, currency)}</span>
              </div>
            ))}
          </div>
        </div>
      ) : (
        <p className="text-muted text-center py-6 text-sm">No expenses yet</p>
      )}
    </Card>
  );
}
